import React, {useEffect, useState} from 'react';
import CustomSelect from '../CustomSelect/CustomSelect';
import CustomInput from '../CustomInput/CustomInput';
import plusSvg from '../../../images/plus_blue.svg';
import minusSvg from '../../../images/minus_blue.svg';
import _ from 'lodash';

const InputErrorMessage = ({formik, name, className = ''}) => {
    return (
        <div className={'form-error ' + className} >
            { _.get( formik.touched, name ) && _.get( formik.errors, name ) }
        </div>
    );
};

const NewPhone = ({index, deleteFunc, formik}) => {
    useEffect(()=>{
        // Si el teléfono ya existe (edición) se respeta el valor cargado
        if (!formik.values.phoneNumbers[index+1]) {
            formik.values.phoneNumbers[index+1] = {type: 'PERSONAL', number: ''};
        }
    }, []);

    return (
        <>
            <div className={'phones-container'}>
                <div style={{flex: 1}}>
                    <CustomSelect
                        label="Teléfonos"
                        placeholder="Categoría"
                        name={`phoneNumbers[${index + 1}].type`}
                        onChange={(value) => formik.setFieldValue(`phoneNumbers[${index + 1}].type`, value)}
                        value={formik.values.phoneNumbers[index + 1]?.type || 'OFFICE'}
                        options={[
                            {value: 'PERSONAL', label: 'Personal'},
                            {value: 'OFFICE', label: 'Oficina'},
                            {value: 'OTHER', label: 'Otro'},
                        ]}
                    />
                </div>
                <div className='number-container'>
                    <CustomInput
                        label="Número"
                        placeholder="Número"
                        name={`phoneNumbers[${index + 1}].number`}
                        onChange={(value) => formik.setFieldValue(`phoneNumbers[${index + 1}].number`, value)}
                        value={formik.values.phoneNumbers[index + 1]?.number}
                        type="text"
                        style={{flex: 1}}
                    />
                    <img src={minusSvg} alt="plus"
                         onClick={deleteFunc}
                         className={'plus-button'}
                    />
                </div>
            </div>
            <div className="eu-div-input">
                <InputErrorMessage formik={formik} name={`phoneNumbers[${index + 1}].number`} className='eu-input-l'/>
            </div>
        </>
    );
};
export const CustomPhone = ({formik}) => {
    // Los teléfonos ya cargados (más allá del primero) se muestran de entrada
    const initialExtraPhones = Math.max((formik?.values?.phoneNumbers?.length || 0) - 1, 0);
    const [phoneKeys, setPhoneKeys] = useState([...Array(initialExtraPhones)].map((x, i) => i));
    const [nextPhone, setNextPhone] = useState(initialExtraPhones);

    if (!formik) {
        return <div>Error: Formik no está definido.</div>;
    }

    const phoneNumbers = formik.values.phoneNumbers || [];

    const addPhone = () => {
        const newPhone = { type: 'PERSONAL', number: '' };
        formik.setFieldValue('phoneNumbers', [...phoneNumbers, newPhone]); // Asegura que siempre sea un array
        setPhoneKeys([...phoneKeys, nextPhone]);
        setNextPhone(nextPhone + 1);
    };


    const deletePhone = (key, index = null) => {
        if (index !== null) {
            formik.setFieldValue(`phoneNumbers[${index}]`, undefined);
        }
        setPhoneKeys(phoneKeys.filter((k) => k !== key));
    };

    return (
        <>
            <div className={'phones-container'}>
                <div style={{flex: 1}}>
                    <CustomSelect
                        label={'Teléfonos'}
                        placeholder={'Tipo'}
                        onChange={(value) => {
                            formik.setFieldValue('phoneNumbers[0].type', value);
                        }}
                        value={formik.values.phoneNumbers[0]?.type || 'PERSONAL'}
                        options={[
                            {value: 'PERSONAL', label: 'Personal'},
                            {value: 'OFFICE', label: 'Oficina'},
                            {value: 'OTHER', label: 'Otro'},
                        ]}
                    />
                </div>
                <div className='number-container'>
                    <CustomInput
                        label="Número"
                        placeholder="Número"
                        onChange={(value) =>
                            formik.handleChange({
                                target: {
                                    name: 'phoneNumbers[0].number',
                                    value: value,
                                },
                            })
                        }
                        value={formik.values.phoneNumbers[0]?.number}
                        type={'text'}
                    />
                    <img
                        src={plusSvg}
                        alt="plus"
                        onClick={addPhone}
                        className={'plus-button'}
                    />
                </div>
            </div>
            <div className="eu-div-input">
                <InputErrorMessage formik={formik} name='phoneNumbers[0].number' className='eu-input-l'/>
            </div>
            {phoneKeys.map((k, i) =>
                <NewPhone key={k} index={i} deleteFunc={() => deletePhone(k, i + 1)} formik={formik}/>,
            )}
        </>
    );
};
